import { Inject, Injectable } from '@angular/core';
import * as Constants from '@emi/shared/constants';
import { Observable } from 'rxjs';
import { Email, Office, TechSupport, SharedConfig, SHARED_CONFIG, AccountManager } from '@emi/shared/models';
import { select, Store } from '@ngrx/store';
import { HttpHeader, HttpService } from '../http.service';
import { AuthState } from 'libs/shared/state/auth/src/lib/auth.reducer';
import { selectAuthState } from 'libs/shared/state/auth/src/lib/auth.selectors';

@Injectable({
    providedIn: 'root',
})
export class PassportHelpService {
    private authState: AuthState;

    constructor(
        @Inject(SHARED_CONFIG) private config: SharedConfig,
        private httpService: HttpService,
        private authStore: Store<AuthState>
    ) {
        this.authStore.pipe(select(selectAuthState)).subscribe((state) => (this.authState = state));
    }

    public getOffices(): Observable<Office[]> {
        return this.httpService.getHttp<Office[]>(
            Constants.ServiceConstants.PASSPORT_HELP_OFFICES,
            undefined,
            undefined,
            this.config.passportHelpServiceUrl
        );
    }

    public getTechSupport(): Observable<TechSupport> {
        return this.httpService.getHttp<TechSupport>(
            Constants.ServiceConstants.PASSPORT_HELP_TECH_SUPPORT,
            undefined,
            undefined,
            this.config.passportHelpServiceUrl
        );
    }

    public sendFeedback(email: Email): Observable<boolean> {
        return this.httpService.postHttp<boolean>(
            Constants.ServiceConstants.PASSPORT_HELP_FEEDBACK,
            email,
            this.config.passportHelpServiceUrl
        );
    }

    public getAccountManagers(country?: string): Observable<AccountManager[]> {
        const headers: HttpHeader[] = [
            { name: 'emi-subscriber-id', value: String(this.authState.subscription.id) },
            { name: 'emi-subscriber-jwt', value: this.authState.subscriberJwt },
        ];

        return this.httpService.getHttp<AccountManager[]>(
            Constants.ServiceConstants.PASSPORT_HELP_ACCOUNT_MANAGERS,
            { country },
            headers,
            this.config.passportHelpServiceUrl
        );
    }
}
